import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push, goBack } from 'react-router-redux';
import withGlobals from '../../withGlobals';
import compact from 'lodash/compact';
import omit from 'lodash/omit';
import { showMenu, hideMenu, hideToast } from '../../store/actions';
import seo from 'shared/lib/seo';
import Toast from '../../components/Toast';
import TopNavBar from '../../components/TopNavBar';
import * as bopApi from '../../api/bop';
import withSubapp from 'shared/lib/apps/BopApp/hoc';

class BopContainer extends Component {
  componentDidMount() {
    seo.setProps({
      title: 'Small Business Insurance | Sure',
      description:
        'Get a Business Owners Policy for Small Business through Sure.',
      url: 'https://www.sureapp.com/small-business-insurance',
    });
  }

  render() {
    return (
      <div className="BOP">
        {!this.props.isEmbed &&
          compact(this.props.location.pathname.split('/')).length > 1 && (
            <TopNavBar
              isLoggedIn={this.props.isLoggedIn}
              userFullName={this.props.userFullName}
              isMenuOpen={this.props.isMenuOpen}
              activeLink={this.props.location.pathname}
              onHideMenu={this.props.hideMenu}
              onShowMenu={this.props.showMenu}
            />
          )}
        {React.cloneElement(this.props.children, omit(this.props, 'children'))}
        {this.props.toast && (
          <Toast
            message={this.props.toast.message}
            sureStyle={this.props.toast.style}
            onDismiss={this.props.hideToast}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: !!state.authToken,
    isMenuOpen: state.isMenuOpen,
    toast: state.toast,
    account: state.account,
    userFullName: [state.account.firstName, state.account.lastName].join(' '),
    isEmbed: state.isEmbed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideMenu: bindActionCreators(hideMenu, dispatch),
    hideToast: bindActionCreators(hideToast, dispatch),
    navTo: bindActionCreators(push, dispatch),
    goBack: bindActionCreators(goBack, dispatch),
    showMenu: bindActionCreators(showMenu, dispatch),
  };
};

const enhance = compose(
  withRouter,
  withGlobals({
    analyticsPrefix: 'BOP',
  }),
  withSubapp(bopApi),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(BopContainer);
